import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/LeadImport";

export const Import = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const GetRows = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:importId/Rows`, options);

export default {
  Import,
  GetAll,
  GetRows,
};
